import React from "react"
import { Link } from "gatsby"
import Header from "../components/header"

export default class Contact extends React.Component {
  componentDidMount() {
    const x = document.querySelector("#c").getContext(`2d`) // canvas element 2D context
    x.lineWidth = 2
    let seed = Date.now() // seed for random generaton, can be replaced with hardcoded value
    let s, i, j, pass, X, Y
    let R = () => {
      return ((Math.sin(++s + i * i) + 1) * 1e9) % 256 | 0 // get a seeded random integer between 0-256
    }
    for (i = 32 * 16; i--; ) {
      // for each sprite (32 rows x 16 columns)
      for (pass = 4; pass--; ) {
        // 4 passes, outline left/right and fill left/right
        for (s = seed, j = (R() / 5 + 50) | 0; j--; ) {
          // set seed, randomize max sprite
          X = j & 7 // X pixel index in sprite
          Y = j >> 3 // Y pixel index in sprite
          if (R() < 19) {
            // small chance of new color
            x.fillStyle = `rgb(${R()},${R()},${R()})` // randomize color
          } else {
            const n = pass & 2 ? "strokeRect" : "fillRect" // stroke first for outline then fill
            const xPos = 7 + (i % 32) * 16 - (pass % 2) * 2 * X + X // x pos, flipped if pass is even
            const yPos = 2 + (i >> 5) * 16 + Y // y pos
            if (R() ** 2 / 2e3 > X * X + (Y - 5) ** 2) {
              // distance from center vs random number
              x[n](xPos, yPos, 1, 1)
            }
          }
        }
      }
    }
  }
  render() {
    return (
      <div style={{ color: `teal` }}>
        <Link to="/">Home</Link>
        <Link to="/dotGradition">dotGradition</Link>
        <Header headerText="Contact" />
        <p>Send us a message!</p>
        <canvas
          id="c"
          width="512"
          height="256"
          style={{ width: "100%", imageRendering: "pixelated" }}
        ></canvas>
      </div>
    )
  }
}

// Tiny Sprite Sheet Generator - Frank Force 2020 - MIT License
